export { default as CollectionProduct } from './CollectionProduct';
